import Alert from "react-bootstrap/Alert";

/**
 * Availability warnings for an appointment's Start / End window.
 *
 * POST /appointments/calculated returns codes in `warnings` and books the
 * window it was asked for regardless — nothing here blocks a save, so this is
 * advisory copy, not validation. It renders directly under the Start and End
 * inputs in both appointment modals rather than as a banner above the modal
 * body, so the warning sits next to the two fields that caused it.
 */
const WARNING_COPY = {
  HARD_CONFLICT:
    "This appointment overlaps with another booking. It will be scheduled — confirm this is intentional before saving.",
  AVAILABILITY_CONFLICT:
    "The practitioner is not available at this time. It will be scheduled, please ensure availability.",
  OUTSIDE_BUSINESS_HOURS:
    "The appointment falls outside of standard business hours. It will be scheduled, please ensure availability.",
};

/** Warning codes from the backend → user-facing lines. Unknown codes drop. */
export function warningMessages(warnings) {
  if (!Array.isArray(warnings)) return [];
  return warnings.map((code) => WARNING_COPY[code]).filter(Boolean);
}

export default function AppointmentTimeWarnings({ messages }) {
  if (!messages?.length) return null;

  return (
    <Alert variant="warning" className="mt-1 mb-2 py-2">
      {messages.length === 1 ? (
        <span className="small">{messages[0]}</span>
      ) : (
        <ul className="mb-0 ps-3 small">
          {messages.map((text, idx) => (
            <li key={idx}>{text}</li>
          ))}
        </ul>
      )}
    </Alert>
  );
}
